module.exports = __webpack_public_path__ + "img/p3.f26eb0fd.png";